export const MAX_TABLE_HEIGHT = 550;
export const MAX_HALF_TABLE_HEIGHT = 242;
export const ACTION_TABLE_COLUMN_WIDTH = '80px';
export const STATUS_PAGE_URL = 'https://status.commercetools.com/';
export const PROJECT_SETTINGS =
  'https://docs.commercetools.com/api/projects/project';
export const UTC = 'UTC';
